import { Icon, IconProps } from './Icon';

export const StopsIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.33325 15.8327L6.66659 4.16602M13.3333 4.16602L16.6666 15.8327M9.99992 6.66602V4.99935M9.99992 10.8327V9.16602M9.99992 14.9993V13.3327"
        stroke="#0098F0"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);
